import "./footer.scss";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__coded-by">
        Coded by
        <a className="footer__link" href="https://github.com/laurenstrapagiel"> Lauren Strapagiel</a>
      </p>
    </footer>
  );
}

export default Footer;
